import { Building2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";
import { STAFF_ROUTES } from "@/src/staff/constants/staff-routes";

const STAFF_NAV_ITEMS = [{ key: "communities", path: STAFF_ROUTES.COMMUNITIES, icon: Building2, labelKey: "sidebar.communities" }] as const;

interface StaffSidebarProps {
	onNavigate?: () => void;
}

export function StaffSidebar({ onNavigate }: StaffSidebarProps) {
	const { t } = useTranslation("staff");

	return (
		<aside className={`flex flex-col bg-white dark:bg-neutral-900 ${onNavigate ? "w-full" : "h-screen w-60 border-r border-divider"}`}>
			<div className="border-b border-divider px-4 py-4">
				<p className="text-xs font-semibold uppercase tracking-wide text-foreground/40">{t("sidebar.title")}</p>
				<p className="mt-1 text-sm font-semibold text-foreground">{t("sidebar.subtitle")}</p>
			</div>

			<nav className="flex-1 px-2 py-4">
				<ul className="space-y-1">
					{STAFF_NAV_ITEMS.map((item) => (
						<li key={item.key}>
							<NavLink
								to={item.path}
								onClick={onNavigate}
								className={({ isActive }) =>
									`flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
										isActive ? "bg-accent-soft-hover text-accent" : "text-foreground/70 hover:bg-accent/10 hover:text-accent/90"
									}`
								}
							>
								<item.icon size={20} />
								<span>{t(item.labelKey)}</span>
							</NavLink>
						</li>
					))}
				</ul>
			</nav>
		</aside>
	);
}
